import React from 'react';

// Left tail for received messages (pointing left)
export const LeftTail = ({ color = '#E8E5E0', size = 12 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 12 12" 
    style={{ 
      position: 'absolute', 
      bottom: 0, 
      left: -size + 1, // Overlap slightly with bubble
      fill: color 
    }}
  >
    <path d="M 12 12 L 12 0 L 0 12 Z" />
  </svg>
);

// Right tail for sent messages (pointing right)
export const RightTail = ({ color = '#e3f2fd', size = 12 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 12 12" 
    style={{ 
      position: 'absolute', 
      bottom: 0, 
      right: -size + 1, // Overlap slightly with bubble
      fill: color 
    }}
  >
    <path d="M 0 12 L 0 0 L 12 12 Z" />
  </svg>
);
